export default __webpack_public_path__ + "static/aboutus-fda7b132c3a4a1c59ae3239c5ec78a3d.png";